module.exports = __webpack_public_path__ + "static/media/cherries.c4f468bd.svg";